import parseCryptoToken from "../../../../../utils/parseCryptoToken";
import {NETWORKS_DETAILED_NAMES} from "../../../../../constants/networks";
import upperFirst from "mn-utils/upperFirst";
import toLower from "mn-utils/toLower";

export default (trxData) => {
  const NETWORK_SYNONYMS = {
    matic: 'Polygon'
  };

  const parsedCryptoToken = parseCryptoToken(trxData.cc_code);
  const BPaySymbol = 'EUR (Binance Pay)';
  const cryptoCurrencyCode = parsedCryptoToken[1] === 'EUR' ? BPaySymbol : parsedCryptoToken[1];

  const networkRaw = NETWORK_SYNONYMS[trxData.network] || trxData.network || parsedCryptoToken[0];
  const network = NETWORKS_DETAILED_NAMES[networkRaw] || upperFirst(networkRaw || '');

  const STATUS_MAP = {
    pending: 'draft',
    canceled: 'cancelled',
  };

  const _status = toLower(trxData.status || '');
  const status = STATUS_MAP[_status] || _status;

  return {
    invoiceId: trxData.invoice_id,
    orderId: trxData.order_id,
    paymentId: trxData.payment_id,
    refundId: trxData.refund_id,
    auctionId: trxData.auction_id,

    invoiceNumber: trxData.invoice_number || trxData.invoice_id,
    desc: trxData.description,

    timeOfInvoice: trxData.invoice_dt,
    timeOfExpiration: trxData.expired_at,

    hash: trxData.hash,
    phone: trxData.phone,

    fiatAmount: trxData.invoice_fiat_amount,
    fiatCode: trxData.invoice_fiat_code,

    currencyAmount: trxData.cc_amount,
    currencyCode: cryptoCurrencyCode,
    network,

    feeCode: trxData.fee_code,
    feeAmount: trxData.fee_amount,

    files: trxData.files || [],
    refundsList: trxData.refunds || [],
    refundableAmount: trxData.refundable_amount || 0,

    buyerName: trxData.buyer_name,
    company: trxData.company,
    email: trxData.email,

    status
  }
}
